import type { BaseMarkupComponent } from '~/models/BaseMarkupComponent.model';
import FetchFactory from '../factory';

const ENDPOINT_PATH = '/api-electra/Category/GetCategoryListPage';

export type MarkupData = {
  PageContent: BaseMarkupComponent[];
  MetaTitle?: string;
  MetaDescription?: string;
  MetaKeywords?: string;
};

class CategoryModule extends FetchFactory<any> {
  async getCategory(
    categoryId: number,
    onlyPreOwnedProducts: boolean | null = null,
  ): Promise<MarkupData> {
    const url = ENDPOINT_PATH;
    const categoryData = await this.get(url, {
      params: {
        categoryId,
        onlyPreOwnedProducts:
          onlyPreOwnedProducts !== null ? onlyPreOwnedProducts : undefined,
      },
    });
    return categoryData || {};
  }
}

export default CategoryModule;
